import React, { useMemo, useState } from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";

export default function AdminLayout({ children }) {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const [open, setOpen] = useState(false);

  const sidebar = useMemo(
    () => <AdminSidebar onNavigate={() => setOpen(false)} />,
    [],
  );

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AdminTopbar
        title="Admin"
        subtitle="Gestão interna ONURB"
        onMenuClick={() => setOpen(true)}
        showMenu={!isLg}
      />

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: { width: 320, p: 2, bgcolor: "background.default" },
        }}
      >
        {sidebar}
      </Drawer>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "280px 1fr" },
          gap: 3,
          px: { xs: 2, md: 3 },
          py: 3,
          alignItems: "start",
        }}
      >
        {isLg ? sidebar : null}

        <Box sx={{ maxWidth: "1600px", width: "100%" }}>{children}</Box>
      </Box>
    </Box>
  );
}
